import auth from './auth';
import base from './base';
import chat from './chat';
import common from './common';
import customer from './customer';
import datasreen from './datascreen';
import history from './history';
import homepage from './homepage';
import inspection from './inspection';
import report from './report';
import robot from './robot';
import setting from './setting';
import tickets from './tickets';

export default {
  ...common,
  ...auth,
  ...base,
  ...chat,
  ...customer,
  ...datasreen,
  ...history,
  ...homepage,
  ...inspection,
  ...report,
  ...robot,
  ...setting,
  ...tickets
};
